import { useQuery } from 'react-query'
import { listHardware } from './hardware.api'
import { fetchCountries } from 'src/helpers/lopay_api_helper'

export function useHardware() {
  return useQuery('hardware', listHardware)
}

export function useCountries() {
  return useQuery('countries', fetchCountries, { staleTime: Infinity })
}
